<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <!-- Payroll -->
        <v-tab-item>
          <v-autocomplete
            v-model="monthlyReport"
            label="Report Types"
            :items="monthlyReportTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />

          <monthly-payroll-summary
            v-if="monthlyReport === 'Monthly Payroll Summary'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
          <monthly-payroll-details
            v-if="monthlyReport === 'Monthly Payroll Details'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
          <cost-center-payroll-report
            v-if="monthlyReport === 'Monthly Payroll Summary By Cost Center'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
          <company-payroll-report
            v-if="monthlyReport === 'Monthly Payroll Summary By Company'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />        
        </v-tab-item>

        <!-- Management-->
        <v-tab-item>
          <v-autocomplete
            v-model="managementReport"
            label="Report Types"
            :items="managementReports"
            item-text="name"
            class="pt-5 px-3"
            style="background:white"
            autofocus
          />

          <yearly-payroll-details-by-individual
            v-if="managementReport === 'Yearly Payroll Details by Individual'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-summary-listing
            v-if="managementReport === 'Summary Listing'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-details-by-company
            v-if="managementReport === 'Yearly Payroll Details by Company'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-details-by-states
            v-if="managementReport === 'Yearly Payroll Details by States'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-details-by-positions
            v-if="managementReport === 'Yearly Payroll Details by Position'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-details-by-departments
            v-if="managementReport === 'Yearly Payroll Details by Department'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-earning-report-by-state
            v-if="managementReport === 'Yearly Earning Report by State'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-details-by-individual-and-company
            v-if="managementReport === 'Yearly Payroll Details by Individual & Company'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <yearly-payroll-expenditure
            v-if="managementReport === 'Payroll Expenditure'"
            :companies="companies"
            :cost-centers="costCenters"
            :positions="positions"
            :departments="departments"
            :payroll-periods="payrollPeriods"
            class="mb-2"
          />
          <monthly-variance-report
            v-if="managementReport === 'Variance Report'"
            :years="years"
            class="mb-2"
          />
        </v-tab-item>

        <!-- Employee-->
        <v-tab-item>
          <div>
            <v-container
              class="full-height"
              fluid
            >
              <export-payroll-employee-statutory
                v-if="$hasPermissionTo(['export employee statutory'])"
                class="mb-2"
              />

              <export-payroll-employee-contribution
                v-if="$hasPermissionTo(['export employee contributions'])"
                class="mb-2"
              />
            </v-container>
          </div>               
        </v-tab-item>      
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      MonthlyPayrollSummary: () => import('@/components/hris/payroll/report/monthly-report/MonthlyPayrollSummary'),
      MonthlyPayrollDetails: () => import('@/components/hris/payroll/report/monthly-report/MonthlyPayrollDetails'),
      CostCenterPayrollReport: () => import('@/components/hris/payroll/report/monthly-report/CostCenterPayrollReport'),
      CompanyPayrollReport: () => import('@/components/hris/payroll/report/monthly-report/CompanyPayrollReport'),

      YearlyPayrollDetailsByIndividual: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByIndividual'),
      YearlySummaryListing: () => import('@/components/hris/payroll/report/yearly-report/YearlySummaryListing'),
      YearlyPayrollDetailsByCompany: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByCompany'),
      YearlyPayrollDetailsByStates: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByStates'),
      YearlyPayrollDetailsByPositions: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByPositions'),
      YearlyPayrollDetailsByDepartments: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByDepartment'),
      YearlyEarningReportByState: () => import('@/components/hris/payroll/report/yearly-report/YearlyEarningReportByState'),
      YearlyPayrollDetailsByIndividualAndCompany: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollDetailsByIndividualAndCompany'),
      YearlyPayrollExpenditure: () => import('@/components/hris/payroll/report/yearly-report/YearlyPayrollExpenditure'),
      MonthlyVarianceReport: () => import('@/components/hris/payroll/report/yearly-report/MonthlyVarianceReport'),

      ExportPayrollEmployeeContribution: () => import('@/components/hris/export/payroll/employee-contribution/EmployeeContribution'),
      ExportPayrollEmployeeStatutory: () => import('@/components/hris/export/payroll/employee-statutory/EmployeeStatutory'),      
    },

    data () {
      return {
        loading: false,
        companies: [],
        positions: [],
        departments: [],
        costCenters: [],
        years: [],
        payrollPeriods: [],
        tabItems: this.$hasPermissionTo(['view payroll export']) ? [
          { name: 'Monthly Reports' },
          { name: 'Yearly Reports' },
          { name: 'Employee' },
        ] : [
          { name: 'Monthly Reports' },
          { name: 'Yearly Reports' },
        ],
        active: 0,

        monthlyReport: null,
        monthlyReportTypes: [
          { name: 'Monthly Payroll Summary' },
          { name: 'Monthly Payroll Details' },
          { name: 'Monthly Payroll Summary By Cost Center' },
          { name: 'Monthly Payroll Summary By Company' },
        ],

        managementReport: null,
        managementReports: [
          { name: 'Yearly Payroll Details by Individual' },
          { name: 'Yearly Payroll Details by Company' },
          { name: 'Yearly Payroll Details by States' },
          { name: 'Yearly Payroll Details by Position' },
          { name: 'Yearly Payroll Details by Department' },
          { name: 'Yearly Earning Report by State' },
          { name: 'Yearly Payroll Details by Individual & Company' },
          { name: 'Summary Listing' },
          { name: 'Payroll Expenditure' },
          { name: 'Variance Report' },
        ],
      }
    },
    created () {
      this.loading = true
        
      Promise.all([
        this.$api.payrollPeriods().list('?year=distinct'),
        this.$api.hrisCompanies().list(),
        this.$api.payrollPeriods().list(),
        this.$api.costCenters().listAll(),
        this.$api.positions().list(),
        this.$api.hrisDepartments().list(['name'], false, true),
      ])
        .then(([years, companies, payrollPeriods, costCenters, positions, departments]) => {
          this.years = years.data
          this.companies = _.orderBy(companies.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })
          this.costCenters = _.orderBy(costCenters.data, ['name'], ['asc'])

          this.payrollPeriods = _.orderBy(
            payrollPeriods.data.filter(period => period.payroll_cycle_transactions.length > 0),
            ['payroll_date'],
            ['desc']
          )
          
          this.positions = positions.data.map(pos => ({
            id: pos.id,
            label: `${pos.name} (${pos.job_grade.job_group.name})`,
          }))

          this.departments = departments.data

          this.loading = false
        })
    },
  }
</script>
